import React, { Component } from 'react'
import ReactTable from 'react-table'
import {
  Button,
  Form,
  Modal,
  Popconfirm,
  Input,
  Table,
  AutoComplete,
  Icon,
  Radio,
  message,
  Tooltip
} from 'antd'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import Loader from '../../util/Loader'
import { actions as rfiActions } from '../../redux/modules/leadFunctions/leadRFIActions'
import { actions as companiesActions } from '../../redux/modules/companiesActions'
import { convertToOption, filterCaseInsensitive, getSelectedOrganization } from '../../util'
import _ from 'lodash'
import OrganizationQuickAdd from '../../components/organization//OrganizationQuickAdd'
import { actions as organizationsActions } from '../../redux/modules/organizationsActions'
import Attachments from '../../components/attachments/Attachments'
import config from '../../config'

import * as authSelectors from '../../selectors/auth'

const { API_BASE } = config

const FormItem = Form.Item
const RadioButton = Radio.Button
const RadioGroup = Radio.Group
const { Column } = Table
const { TextArea } = Input
const propTypes = {}

const AddItemArea = styled.div`
  padding-top: 10px;
  margin-bottom: 10px;
  padding-right: 10px;
`
const EditableCell = ({ editable, value, onChange }) => (
  <div>
    {editable ? (
      <Input style={{ margin: '-5px 0' }} value={value} onChange={e => onChange(e.target.value)} />
    ) : (
      value
    )}
  </div>
)

class LeadRFIs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      contentData: null
    }

    this.props.leadRFIsRefresh({
      leadId: this.props.leadId
    })
    this.props.getAllCompaniesVendorsClients()
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.shortcutItemId &&
      this.props.leadRFIActions.leadRFIs !== prevProps.leadRFIActions.leadRFIs
    ) {
      const highLightEstimate = _.filter(
        this.props.leadRFIActions.leadRFIs.data,
        rfi => rfi.id === parseInt(this.props.shortcutItemId, 10)
      )
      this.handleRowClick(highLightEstimate[0])
      this.props.clearHighlight()
    }

    if (this.props.leadRFIActions.leadRfiItems !== prevProps.leadRFIActions.leadRfiItems) {
      this.setState({
        rfiItems: this.props.leadRFIActions.leadRfiItems.data
      })
    }
  }

  handleRowClick = row => {
    this.setState({
      modalVisible: true,
      currentId: row.id,
      contentData: row
    })
    this.props.getLeadRfiData({
      leadId: this.props.leadId,
      rfiId: row.id
    })
    this.props.getLeadRfiAttachments({ leadRfiId: row.id })
  }

  handleAddButton = () => {
    this.setState({
      modalVisible: true,
      currentId: 0,
      contentData: null,
      rfiItems: [],
      addQuestionInput: '',
      addResponseInput: ''
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false })
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      values.organization_id = getSelectedOrganization(
        this.props.companiesActions.payload.data,
        values.organization_id
      )

      if (this.state.currentId === 0) {
        this.props.createLeadRFI({
          leadId: this.props.leadId,
          content: values,
          rfiItems: this.state.rfiItems,
          userId: this.props.user.userId
        })
      } else {
        this.props.updateLeadRFI({
          leadId: this.props.leadId,
          rfiId: this.state.currentId,
          content: values,
          rfiItems: this.state.rfiItems,
          userId: this.props.user.userId
        })
      }

      form.resetFields()
      message.success('Changes saved.')
      this.setState({
        contentData: null,
        currentId: 0,
        modalVisible: false,
        rfiItems: [],
        addQuestionInput: '',
        addResponseInput: ''
      })
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteLeadRFI({
      leadId: this.props.leadId,
      rfiId: this.state.currentId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false
    })
  }

  renderColumns(text, record, column) {
    return (
      <EditableCell
        editable={record.isEditingRow}
        value={text}
        onChange={value => this.handleItemsInputChange(value, record.id, column)}
      />
    )
  }

  handleAddInputChange = (value, input) => {
    this.setState({ [input]: value })
  }

  handleItemsInputChange = (value, key, column) => {
    const groupedItems = this.state.rfiItems.map(row => {
      if (row.id === key) row[column] = value
      return row
    })
    this.setState({
      rfiItems: groupedItems
    })
  }

  handleAddItemClick = () => {
    const items = this.state.rfiItems

    items.push({
      question: this.state.addQuestionInput,
      response: this.state.addResponseInput,
      id: items.length
    })
    this.setState({
      addQuestionInput: '',
      addResponseInput: '',
      rfiItems: items
    })
  }

  editRow = rowId => {
    const groupedItems = this.state.rfiItems.map(row => {
      if (row.id === rowId) row.isEditingRow = true
      return row
    })
    this.setState({
      rfiItems: groupedItems
    })
  }

  saveRow = rowId => {
    const groupedItems = this.state.rfiItems.map(row => {
      if (row.id === rowId) {
        row.isEditingRow = false
      }
      return row
    })
    this.setState({
      rfiItems: groupedItems
    })
  }

  deleteRow = rowId => {
    const groupedItems = this.state.rfiItems.filter(item => item.id !== rowId)

    this.setState({
      rfiItems: groupedItems
    })
  }

  /* Organization Quick Add */
  handleQuickAddOrganization = organization => {
    this.props.createNewOrganization({
      organization: organization,
      userId: this.props.user.userId
    })
    setTimeout(() => {
      this.props.getAllCompaniesVendorsClients()
    }, 1000)
  }

  handleBlurOrganization = organization => {
    if (organization !== '')
      this.setState({
        quickAddModalVisibility:
          _.findIndex(this.props.companiesActions.payload.data, { id: +organization }) < 0 &&
          _.findIndex(this.props.companiesActions.payload.data, { name: organization }) < 0
            ? true
            : false
      })
  }

  handleCancelQuickAdd = () => {
    this.setState({
      quickAddModalVisibility: !this.state.quickAddModalVisibility
    })
  }
  /* End Organization Quick Add */

  /* attachments */
  uploadAttachment = param => {
    this.props.uploadLeadRfiAttachment({
      formData: param.formData,
      leadRfiId: this.state.currentId
    })
  }

  updateAttachmentDescription = param => {
    this.props.updateLeadRfiAttachmentDescription(param)
  }

  deleteAttachment = param => {
    this.props.deleteLeadRfiAttachment(param)
  }

  render() {
    const { contentData } = this.state
    const allCompanies =
      this.props.companiesActions &&
      this.props.companiesActions.payload &&
      this.props.companiesActions.payload.data
    const { getFieldDecorator } = this.props.form
    if (!this.props.leadRFIActions.leadRFIs) {
      return <Loader />
    }
    return (
      <div>
        <OrganizationQuickAdd
          modalVisible={this.state.quickAddModalVisibility}
          handleCancel={this.handleCancelQuickAdd}
          handleQuickAddOrganization={this.handleQuickAddOrganization}
          organizartionType={'Client'}
        />
        <Modal
          visible={this.state.modalVisible}
          title="RFI's"
          okText={contentData ? 'Save Changes' : 'Create'}
          onCancel={this.handleCancel}
          onOk={this.handleCreate}
          width={800}
          maskClosable={false}
        >
          {contentData && (
            <div className="row">
              <div className="col-6">
                <h2>RFI #{contentData.id}</h2>
              </div>
              <div className="col-md-6 text-right">
                <a href={`${API_BASE}/api/lead/rfis/${contentData.id}/print`} target="_blank">
                  <Button icon="printer">Print RFI</Button>
                </a>
                <FormItem label="Status">
                  {getFieldDecorator('status', {
                    initialValue: contentData ? contentData.status : ''
                  })(
                    <RadioGroup>
                      <RadioButton value="Created">Created</RadioButton>
                      <RadioButton value="Closed">Closed</RadioButton>
                    </RadioGroup>
                  )}
                </FormItem>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-md-6">
              <FormItem label="Company">
                {getFieldDecorator('organization_id', {
                  rules: [
                    {
                      required: true,
                      message: 'Company cannot be blank.'
                    }
                  ],
                  initialValue: contentData ? contentData.organization_name : ''
                })(
                  <AutoComplete
                    dataSource={convertToOption(allCompanies)}
                    filterOption={(inputValue, option) =>
                      option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                    onBlur={this.handleBlurOrganization}
                    style={{ width: 320 }}
                    placeholder="Search for a company/vendor"
                  >
                    <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                  </AutoComplete>
                )}
              </FormItem>
            </div>
            <div className="col-md-6">
              <FormItem label="Attention">
                {getFieldDecorator('attention', {
                  initialValue: contentData ? contentData.attention : ''
                })(<Input placeholder="Attention to..." />)}
              </FormItem>
            </div>
          </div>
          <Form layout="vertical">
            <FormItem label="Description">
              {getFieldDecorator('description', {
                rules: [
                  {
                    required: true,
                    message: 'Description cannot be blank.'
                  }
                ],
                initialValue: contentData ? contentData.description : ''
              })(<TextArea placeholder="Describe the RFI..." rows={4} />)}
            </FormItem>
            <Table
              dataSource={this.state.rfiItems}
              size="small"
              bordered
              pagination={false}
              rowKey="id"
            >
              <Column
                title="Question"
                dataIndex="question"
                key="question"
                width={250}
                render={(text, record) => this.renderColumns(text, record, 'question')}
              />
              <Column
                title="Response"
                dataIndex="response"
                key="response"
                render={(text, record) => this.renderColumns(text, record, 'response')}
              />
              <Column
                title=" "
                dataIndex="action"
                key="action"
                render={(text, record) => {
                  return (
                    <div>
                      {record.isEditingRow && (
                        <Button icon="save" onClick={() => this.saveRow(record.id)} />
                      )}
                      {!record.isEditingRow && (
                        <Button icon="edit" onClick={() => this.editRow(record.id)} />
                      )}
                      <Popconfirm
                        title="Are you sure you want to delete this line?"
                        onConfirm={() => this.deleteRow(record.id)}
                        onCancel={this.cancelDelete}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button className="marginLeft5" type="danger" icon="delete" />
                      </Popconfirm>
                    </div>
                  )
                }}
                width={90}
              />
            </Table>
            <AddItemArea>
              <div className="row">
                <div className="col-md-5">
                  <Input
                    placeholder="Question"
                    value={this.state.addQuestionInput}
                    onChange={event =>
                      this.handleAddInputChange(event.target.value, 'addQuestionInput')
                    }
                  />
                </div>
                <div className="col-md-5">
                  <Input
                    placeholder="Response"
                    value={this.state.addResponseInput}
                    onChange={event =>
                      this.handleAddInputChange(event.target.value, 'addResponseInput')
                    }
                  />
                </div>
                <div className="col-md-2 text-right">
                  <Button onClick={() => this.handleAddItemClick()}>Add Item</Button>
                </div>
              </div>
            </AddItemArea>
            {this.state.currentId > 0 && (
              <div className="row">
                <div className="col-12">
                  <Attachments
                    currentId={this.state.currentId}
                    userId={this.props.user.userId}
                    attachmentList={
                      this.props.leadRFIActions.leadRfiAttachments &&
                      this.props.leadRFIActions.leadRfiAttachments.data
                    }
                    loadingAttachments={this.props.leadRFIActions.loadingAttachments}
                    uploadingAttachment={this.props.leadRFIActions.uploadingAttachment}
                    uploadAttachment={this.uploadAttachment}
                    updateAttachmentDescription={this.updateAttachmentDescription}
                    deleteAttachment={this.deleteAttachment}
                    deletingAttachment={this.props.leadRFIActions.deletingAttachment}
                  />
                </div>
              </div>
            )}
            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={this.confirmDelete}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              {contentData && <Button type="danger" icon="delete" />}
            </Popconfirm>
          </Form>
        </Modal>
        <div className="jobsBar">
          RFI's
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;
            <div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD RFI
            </div>
          </div>
        </div>
        {this.props.leadRFIActions.leadRFIs && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTrProps={(state, rowInfo, column, instance) => ({
              onClick: e => this.handleRowClick(rowInfo.original)
            })}
            data={this.props.leadRFIActions.leadRFIs.data}
            columns={[
              {
                columns: [
                  {
                    Header: 'Number',
                    accessor: 'id',
                    maxWidth: 90,
                    className: 'textAlignCenter'
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  },
                  {
                    Header: 'Status',
                    accessor: 'status',
                    maxWidth: 90
                  },
                  {
                    Header: 'Created By',
                    id: 'first_name',
                    accessor: d => {
                      const r = `${d.first_name} ${d.last_name}`
                      return <Tooltip title={r}>{r}</Tooltip>
                    },
                    maxWidth: 150
                  }
                ]
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  leadRFIActions: state.leadRFIActions,
  companiesActions: state.companiesActions,
  organizationsActions: state.organizationsActions,
  user: authSelectors.getUser(state, props)
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign({}, rfiActions, companiesActions, organizationsActions),
    dispatch
  )
})

LeadRFIs.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(LeadRFIs)))



// WEBPACK FOOTER //
// ./src/pages/lead/LeadRFIs.container.js